'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('./layout');

var _layout2 = _interopRequireDefault(_layout);

var _Sider = require('./Sider');

var _Sider2 = _interopRequireDefault(_Sider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_layout2["default"].Sider = _Sider2["default"];
exports["default"] = _layout2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/.2.9.0@antd/lib/layout/index.js
// module id = 438
// module chunks = 0